import { InjectionToken } from '@angular/core';
import { SidePanelRef } from '../models/side-panel-ref';

// Create a new InjectionToken for providing the panel reference.
export const SIDE_PANEL_CONTEXT = new InjectionToken<SidePanelRef>('SIDE_PANEL_CONTEXT');